<template>
  <ButtonTooltip
    v-if="fab"
    v-scroll="onScroll"
    dark
    fixed
    fab
    bottom
    right
    color="primary"
    button-class="bottomTop"
    :tooltip-props="{ 'nudge-bottom': 888, 'nudge-right': 830 }"
    tooltip-text="Go to top"
    icon-name="fa-chevron-up"
    @click="toTop"
  />
</template>

<script>
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"

export default {
  name: "TheAppBar",
  components: { ButtonTooltip },
  data: () => {
    return {
      fab: false,
    }
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop() {
      this.$vuetify.goTo(0)
    },
  },
}
</script>

<style scoped>
.bottomTop {
  bottom: 45px;
}
</style>
